import { faqs } from "../data/faq/faq-data";

export const getFaqsByCategory = (category) => {
  // Get the FAQs from our dictionary
  const categoryFaqs = faqs.filter(({ id }) => category.faqs.includes(id));

  // If there are ids in categoryFaqIds that are not in the faqs array, warn the dev with which ones
  const missingFaqs = category.faqs.filter((id) => !categoryFaqs.find((faq) => faq.id === id));

  if (missingFaqs.length) {
    console.warn(
      `The following FAQ IDs are missing from ${category.CategoryName} FAQ array: ${missingFaqs.join(", ")}`
    );
  }

  // Sort them so their id matches the order in mongoDb
  const order = category.faqs;
  const orderedCategoryFaqs = categoryFaqs.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));

  return orderedCategoryFaqs;
};
